import styled from 'styled-components'

const ZestawienieNameStyle = styled.div`
  display: grid;
  grid-template-columns: 1fr 156px 140px;
  margin: 16px 0 0 0;
  align-items: center;

  .header-text {
    font-family: 'Ubuntu-Light';
    font-size: 24px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
  }

  button {
    width: 140px;
  }
`
export default ZestawienieNameStyle
